import styled, { keyframes } from 'styled-components';

const fader = keyframes`
  50% { opacity: 0.5; }
`;

export const SpinnerWrap = styled.span`
  pointer-events: none;
  aspect-ratio: 1;
  vertical-align: middle;
  width: calc(var(--size-selector, .625rem) * 25);
  display: inline-block;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (prefers-reduced-motion: reduce) {
    svg {
      animation: ${fader} 2s ease infinite;
    }
  }

  .spinner-burst { fill: #FFF; }
  .spinner-center { fill: #000; }
  .spinner-shape-1 { fill: var(--color-1, #00BCFF); }
  .spinner-shape-2 { fill: var(--color-2, #FF2986); }
  .spinner-shape-3 { fill: var(--color-3, #0900DA); }

  &:where(.prs-loading-reverse) svg {
    --color-1: #00BCFF;
    --color-2: #FF2986;
    --color-3: #FFF;
  }

  &:where(.prs-loading-xs) {
    width: calc(var(--size-selector, .625rem) * 2);
  }
  &:where(.prs-loading-sm) {
    width: calc(var(--size-selector, .625rem) * 4);
  }
  &:where(.prs-loading-md) {
    width: calc(var(--size-selector, .625rem) * 6);
  }
  &:where(.prs-loading-lg) {
    width: calc(var(--size-selector, .625rem) * 8);
  }
  &:where(.prs-loading-xl) {
    width: calc(var(--size-selector, .625rem) * 10);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 50000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;
